import { MODO_PARTICIPACAO_ADVOGADO } from './ModoParticipacaoAdvogado';

/**
 * @classdesc Agrupa as regras semânticas relacionadas aos modos de participação de advogados.
 */
export default class ModoParticipacaoBusiness {
    static isModoParticipacaoVirtual(modoParticipacao) {
        return (
            modoParticipacao === MODO_PARTICIPACAO_ADVOGADO.VIRTUAL.codigo ||
            modoParticipacao === MODO_PARTICIPACAO_ADVOGADO.SUSTENTACAO_ORAL_ELETRONICA.codigo
        );
    }
}
